module.exports = __webpack_public_path__ + "media/images/categories/carousel/media-e153814415f2f03319e5daf8b3979caf.jpg";